export const getLinkFromEvent = (url: number): string => {
  const protocol = window.location.protocol;
  const host = window.location.host;
  return `${protocol}//${host}/#/fid/${url}`;
}
